var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"csBox"},[_c('div',{staticClass:"container"},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticClass:"img",style:({
				  '--img':(index*70+item.left)+'px'
			  }),attrs:{"src":item.img},on:{"mouseenter":function($event){return _vm.mouseover(index)},"mouseleave":_vm.mouseout}})}),0),_c('div',{staticClass:"csBoxRight"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.itema.name)+"\n\t\t\t")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }